import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { logbaseService } from "../../services/logbase.service";
import { NgxSpinnerService } from "ngx-spinner";
import { dateFormatPipe } from "../../pipes/dateFormatPipe";
import { ChartsUtils } from './../../chartsUtils/ChartUtils';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { DatePipe } from '@angular/common';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-po-fcdaily",
  templateUrl: "./po-fcdaily.component.html",
  styleUrls: ["./po-fcdaily.component.scss"],
  providers: [dateFormatPipe]
})
export class PoFcdailyComponent implements OnInit {

  daywisearraylength: any;
  resultData: any;
  dailyGraphDates: any = [];
  dailyGraphData: any;
  chartDatesDaily: void;
  dailyPODates: any = [];
  //Bind letibles for Po Daily Table and Chart
  dailyView: any;
  locCodeList = [];
  locDD: any = [];
  suppCodeList: any[];
  dropdownSettings: any;
  suppCode: any;
  locCode: any;
  supPoint: any;
  suppCodeTbl: any;
  suppCodeTbl1: any;
  locCodeTbl: any;
  enableExport: boolean = false;
  datePipe = new DatePipe("en-US");
  disableExport: boolean = true;
  totalDayQuantityArray: any[];
  //End Bind letibles for Po Daily Table and Chart
  name = 'All';
  names = ['All', 'Quantity', 'Weight', 'Volume', 'No. Of Boxes']
  dateHeading
  //Chart Configuration and Data
  public barChartOptions: any = ChartsUtils.getPackageRatioChartOptions();
  public barChartLabels: string[] = ChartsUtils.getDailyPoChartLabel();
  public lineChartColors: Array<any> = ChartsUtils.getDailyPoChartColors();
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;
  public barChartQuantity: any[]
  public barChartWeight: any[]
  public barChartVolume: any[]
  //End Chart Configuration and Data

  //Render Data and Col from Ng2-table Configuration
  public dailyChartLabels: string[];
  public rows: Array<any> = [];
  public columns: Array<any> = [
    { title: "Supplier", name: "supplierCode" },
    { title: "Part No.", name: "partNo" },
    //{ title: "Package Id", name: "packageId" },
    { title: "Location", name: "location" },
    { title: "Delivery Point", name: "deliveryPoint" },
    { title: "Next Process", name: "lineNumber" },
    { title: "Spec", name: "specification" },
  ];
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;

  public config: any = {
    paging: true,
    sorting: { columns: this.columns },
    filtering: { filterString: "" },
    className: ["table-striped", "table-bordered", "poTable"]
  };

  public data: Array<any> = [];
  exportData: any;
  fcdailyView: any;
  downloadData: any[];
  //End Render Data and Col from Ng2-table Configuration

  dropdownSingle: any;
  graphLocStg: any;
  public graphDispBtn: any = true;
  VolumeChartData: any;
  WeightChartData: any;
  QuantityChartData: any;
  showSepFilter;
  stackChartOpt = {
    scaleShowVerticalLines: true,
    responsive: true,
    legend: { position: 'top' },
    scales: {
      xAxes: [
        {
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          }
        }
      ],
      yAxes: [
        {
          stacked: true,
          gridLines: {
            drawOnChartArea: false
          }
        }
      ]
    }
  };
  graphSuppDD: any[];

  constructor(
    private logbaseService: logbaseService,
    private spinner: NgxSpinnerService,
    private ref: ChangeDetectorRef,
    private dateFormatPipe: dateFormatPipe,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    // Angular2 multi select settings and config
    this.dropdownSettings = {
      idField:"id",
      textField:"itemName",
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true
    };
    this.dropdownSingle = {
      singleSelection: true,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: false,
      enableSearchFilter: true
    };

    this.graphLocStg = {
      id:'id',
      textField:'itemName',
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: true
    };

    // this.setFilterData(1);

    this.onChangeTable(this.config, true);
    this.toGetSupplierCode();

    this.VolumeChartData = [];
    this.WeightChartData = [];
    this.QuantityChartData = [];
  }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== "" && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === "desc" ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === "asc" ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(
          this.config.filtering.filterString
        )
      );
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name]) {
          if (
            item[column.name].toString().match(config.filtering.filterString)
          ) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  datefilter(date) {

    let day1Date
    if (date !== undefined) {
      let test = new Date(date)
      let dd = test.getDate(); let mm = test.getMonth() + 1; let yyyy = test.getFullYear();
      let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      let dayName = days[test.getDay()];
      if (dd < 10) { let tt; tt = '0' + dd; dd = tt; }
      if (mm < 10) { let mmm; mmm = '0' + mm; mm = mmm; }
      return day1Date = yyyy + '-' + mm + '-' + dd + ' ' + dayName;
    }
  }


  public onChangeTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    this.showSepFilter = this.name;
    let allselected = this.name;
    this.spinner.show();
    let pageNo;
    let sortData;
    let locSelected = [];
    let suppSelected = [];
    if (page) {
    }

    this.setFilterData(page.page);

    if (page.page == undefined || page.page == null) {
      pageNo = 0;
    } else {
      if (page.page != 0) {
        pageNo = page.page - 1;
      }
    }

    // To enable export feature
    if (this.suppCodeTbl || this.locCodeTbl) {
      if ((this.suppCodeTbl.length > 0 && this.suppCodeTbl.length <= 10) || (this.locCodeTbl.length > 0 && this.locCodeTbl.length <= 10)) {
        if (this.name != 'All') {
          this.enableExport = true;
        } else {
          this.enableExport = false;
        }
      } else {
        this.enableExport = false;
      }
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
      } else {
        sortData = {
          name: "",
          sort: ""
        };
      }
    });

    if (this.locCodeTbl) {
      this.locCodeTbl.forEach(function (value, key) {
        locSelected.push(value.itemName);
      });
    }

    if (this.suppCodeTbl) {

      this.suppCodeTbl.forEach(function (value, key) {
        suppSelected.push(value.itemName);
      });
    }
    if (this.suppCodeTbl1) {

    }

    if (locSelected.length <= 0) {
      locSelected = [];
    }

    if (suppSelected.length <= 0) {
      suppSelected = [];
    }
    let dataToSend = {
      pageNum: pageNo,
      searchValue: this.config.filtering.filterString,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      location: locSelected,
      suplierCode: suppSelected
    };

    this.logbaseService.getFcDailyData(dataToSend).subscribe(result => {
      this.dailyView = result;
      if(this.dailyView){
      this.daywisearraylength=this.dailyView.response.content.length;
      let viewArr;
      let viewData = [];
      let dateTitle = [];
      if (this.dailyView.response.content.length > 0) {

        for (let k = 0; k < this.dailyView.response.content[0].daywiseDetails.length; k++) {
          dateTitle.push({ id: 'Day' + k, title: this.datefilter(this.dailyView.response.content[0].daywiseDetails[k].day), name: this.dailyView.response.content[0].daywiseDetails[k].day })
        }
        this.dateHeading = dateTitle;
        let preDefine = [{ title: "Supplier", name: "supplierCode" },
        { title: "Part No.", name: "partNo" },
        { title: "Location", name: "location" },
        { title: "Delivery Point", name: "deliveryPoint" },
        { title: "Next Process", name: "lineNumber" },
        { title: "Spec", name: "specification" }]
        let columns = preDefine.concat(dateTitle);
        this.columns = columns
        this.data = viewData;
        this.downloadData = viewData;
        this.dateHeading.forEach(element => {
          this.dailyPODates.push(this.datePipe.transform(element.name, 'dd/MM'));
          this.dailyGraphDates.push(this.datePipe.transform(element.name, 'dd/MM/yy'))
        });
        this.dailyChartLabels = this.dailyPODates;
        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.exportData =
          page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.spinner.hide();

      }

      this.length = this.dailyView.response.totalElements;
      let filteredData = this.changeFilter(this.data, this.config);
      let sortedData = this.changeSort(filteredData, this.config);
      this.rows =
        page && config.paging ? this.changePage(page, sortedData) : sortedData;
      this.rerenderTable(this.config, true);
      this.ref.detectChanges();
      this.spinner.hide();
    }
    });
  
  }



  public rerenderTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows =
      page && config.paging ? this.changePage(page, sortedData) : sortedData;
  }

  setFilterData(page) {
    this.spinner.show();

    let suppCode = [];
    let dataResult: any;
    let suppCodeDD = [];
    let pageNo;

    if (page == undefined || page == "null") {
      pageNo = 0;
    } else {
      pageNo = page - 1;
    }

    let dataToSend = {
      pageNum: pageNo,
      searchValue: this.config.filtering.filterString,
      size: this.itemsPerPage,
      sortColumn: "",
      sortType: "",
      location: [],
      suplierCode: []
    };
    let userDetJson = JSON.parse(localStorage.getItem('userDetails'));
    this.logbaseService.getFcDailyData(dataToSend).subscribe(result => {
      dataResult = result;
      this.spinner.hide();
    });
  };

  resetDD() {
    this.locCodeTbl = [];
    this.suppCodeTbl1 = [];
    this.locCode = [];
    this.supPoint = [];
    this.graphDispBtn = true;

    // Enable the location dropdown
    this.graphLocStg = {
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: true
    };

    this.VolumeChartData = [];
    this.WeightChartData = [];
    this.QuantityChartData = [];

    this.onChangeTable(this.config, true);
  }

  getSum(total, num) {
    return total + num;
  }

  toGetSupplierCode() {
    this.spinner.show();
    this.logbaseService.getAllSupplierCode({ "supplierCodes": [] }).subscribe(result => {
      let supplierCode;
      supplierCode = result;
      let suppCodeDD = [];
      let graphSuppDD = [];

      if (supplierCode.response.length > 0) {
        supplierCode.response.forEach(function (value, key) {
          suppCodeDD.push({ id: suppCodeDD.length + 1, itemName: value.supplierCode });
          graphSuppDD.push({ label: value.supplierCode, value: value.supplierCode });

        });
        this.suppCodeList = suppCodeDD;
        this.graphSuppDD = graphSuppDD;
      }
    

      this.spinner.hide();
    });
  }

  onSupplierCodeSelect(item: any) {
    this.locCodeTbl = [];
    this.toGetLocationCode(this.toGetFormatedsendBody(this.suppCodeTbl));
  }
  OnSupplierCodeDeSelect(item: any) {
    this.locCodeTbl = [];
    if (this.suppCodeTbl.length > 0) {
      this.toGetLocationCode(this.toGetFormatedsendBody(this.suppCodeTbl));
    } else {
      this.locCodeList = [];
      this.onChangeTable(this.config, true);
    }
  }

  onSupplierCodeSelectAll(items: any) {
    this.locCodeTbl = [];
    this.toGetLocationCode(this.toGetFormatedsendBody(items));
  }

  onSupplierCodeDeSelectAll(items: any) {
    this.locCodeTbl = [];
    this.locCodeList = [];
    this.onChangeTable(this.config, true);
  }

  toGetLocationCode(locationCode) {
    this.spinner.show();
    
    this.logbaseService.getAllSupplierCode(locationCode).subscribe(result => {
      let LocationCode;
      LocationCode = result;
      let temp = []
      
      if (locationCode && LocationCode.response.length > 0 ) {
        for (let index = 0; index < LocationCode.response.length; index++) {
          if (LocationCode.response.length > 0) {

            if (LocationCode.response[index].locationDetails !== undefined &&
              LocationCode.response[index].locationDetails.length > 0) {
              for (let j = 0; j < LocationCode.response[index].locationDetails.length; j++) {
                temp.push(LocationCode.response[index].locationDetails[j]);
              }
            }
          }
        }
      }
      let locCodeDD = [];
      if (temp.length > 0) {
        temp.forEach(function (value, key) {
          locCodeDD.push({ id: locCodeDD.length + 1, itemName: value });
        });
      } else {
        locCodeDD = [];
      }
      const resultArray = [];
      const map = new Map();
      for (const item of locCodeDD) {
        if (!map.has(item.itemName)) {
          map.set(item.itemName, true);    // set any value to Map
          resultArray.push({
            id: item.id,
            itemName: item.itemName
          });
        }
      }
      let uniqueArray = []
      if (resultArray.length > 0) {
        resultArray.forEach(function (value, key) {
          uniqueArray.push({ id: uniqueArray.length + 1, itemName: value.itemName.location });
        });

      }

      this.locCodeList = uniqueArray;
      this.spinner.hide();
    });
  }

  toGetFormatedsendBody(data) {
    let returnBody = { "supplierCodes": [] }
    if (data.length > 0) {
      for (let index = 0; index < data.length; index++) {
        returnBody.supplierCodes.push(data[index].itemName);
      }
    }
    return returnBody
  }

  exportCSV(exportData) {

    var dateFormatPipeFilter = new dateFormatPipe();
    this.exportData = exportData;

    var specName = this.name;

    var csvData: any = [];
    //var csvObj: any = {};
    var csvDate = {
      day1Title: '', day2Title: '', day3Title: '',
      day4Title: '', day5Title: '', day6Title: '', day7Title: '', day8Title: '', day9Title: '', day10Title: '', day11Title: '', day12Title: '',
      day13Title: '', day14Title: '', day15Title: '', day16Title: '', day17Title: '', day18Title: '', day19Title: '', day20Title: ''
    }

    var dayTitle: any = [];
    var testArr = [];

    this.exportData.response.content[0].daywiseDetails.forEach(function (value, key) {
      dayTitle.push(value.day);
    });

    this.exportData.response.content.forEach(function (value, key) {
      var csvObj: any = {};
      csvObj.supplierCode = value.supplierCode;
      csvObj.partNo = value.partNumber;
      csvObj.location = value.plantName;
      csvObj.deliveryPoint = value.deliveryPoint;
      csvObj.lineNumber = value.lineNumber;
      csvObj.specification = specName;

      value.daywiseDetails.forEach(function (val, k) {
        if (specName == 'Quantity') {
          csvObj["day" + k] = val.dayQuantity;
        }
        if (specName == 'Weight') {
          csvObj["day" + k] = val.dayWeight;
        }
        if (specName == 'Volume') {
          csvObj["day" + k] = val.dayVolume;
        }
        if (specName == 'No. Of Boxes') {
          csvObj["day" + k] = val.dayNumberOfBox;
        }
      });

      csvData.push(csvObj);
    });

    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      // showTitle: true,
      title: 'PO Forecast Daily',
      headers: ['Supplier', 'Part No', 'Location', 'Delivery Point', 'Next Process', 'Spec', dayTitle[0], dayTitle[1], dayTitle[2], dayTitle[3], dayTitle[4], dayTitle[5], dayTitle[6], dayTitle[7], dayTitle[8], dayTitle[9], dayTitle[10], dayTitle[11], dayTitle[12], dayTitle[13], dayTitle[14], dayTitle[15], dayTitle[16], dayTitle[17], dayTitle[18]],
      removeNewLines: true
    };

    new AngularCsv(csvData, 'Po Forecast Daily', options);
  }

  checkFilter() {
  }


  public exportTable(config: any = this.config,
    page: any = { page: 0, itemsPerPage: this.itemsPerPage }
  ): any {

    let allselected = this.name;

    this.spinner.show();
    var pageNo;
    let sortData;

    let locSelected = [];
    let suppSelected = [];


    if (page) {
    }

    if (page.page == undefined || page.page == null) {
      pageNo = 0;
    } else {
      if (page.page != 0) {
        pageNo = page.page - 1;
      }
    }

    // To enable export feature
    if (this.suppCodeTbl || this.locCodeTbl) {
      if ((this.suppCodeTbl.length > 0 && this.suppCodeTbl.length <= 10) || (this.locCodeTbl.length > 0 && this.locCodeTbl.length <= 10)) {
        this.enableExport = true;
      } else {
        this.enableExport = false;
      }
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
      } else {
        sortData = {
          name: "",
          sort: ""
        };
      }
    });

    if (this.locCodeTbl) {
      this.locCodeTbl.forEach(function (value, key) {
        locSelected.push(value.itemName);
      });
    }

    if (this.suppCodeTbl) {

      this.suppCodeTbl.forEach(function (value, key) {
        suppSelected.push(value.itemName);
      });
    }
    if (this.suppCodeTbl1) {

    }

    if (locSelected.length <= 0) {
      locSelected = [];
    }

    if (suppSelected.length <= 0) {
      suppSelected = [];
    }
    let dataToSend = {
      pageNum: 0,
      searchValue: this.config.filtering.filterString,
      size: this.dailyView.response.totalElements,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      location: locSelected,
      suplierCode: suppSelected
    };

    this.logbaseService.getFcDailyData(dataToSend).subscribe(result => {
      this.fcdailyView = result;

      // let viewData = [];
      // this.downloadData = viewData;

      // //this.length = this.fcdailyView.response.totalElements;
      // let filteredData = this.changeFilter(this.data, this.config);
      // let sortedData = this.changeSort(filteredData, this.config);
      // this.exportData =
      //   page && config.paging ? this.changePage(page, sortedData) : sortedData;

      this.spinner.hide();

      this.exportCSV(this.fcdailyView);
    });
  }


  onGraphSuppSel(item: any) {

    var responseData;

    // Disable the location dropdown
    this.graphLocStg = {
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: false
    };

    this.graphDispBtn = false;

    this.locCode = [];

    this.logbaseService.dailyGraphView(item.value).subscribe(result => {
      responseData = result;
      let locCodeList: any = [];
      if (responseData && responseData.response.locWiseDetails) {

        responseData.response.locWiseDetails.forEach(function (value, key) {
          locCodeList.push({ id: key, itemName: value.locationName });
        });

        this.locDD = locCodeList;
      }
    });
  };

  onGraphSuppDeSel(item: any) {
    this.locCode = [];

    this.graphDispBtn = true;

    // Enable the location dropdown
    this.graphLocStg = {
      singleSelection: false,
      text: "Select",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      disabled: true
    };
  };

  showGraphData() {
    this.spinner.show();
    this.VolumeChartData = [];
    this.WeightChartData = [];
    this.QuantityChartData = [];
    var suppID = this.supPoint;
    var responseData: any;
    var graphLoopData;
    var locName = [];

    this.logbaseService.dailyGraphView(suppID).subscribe(result => {
      responseData = result;
      this.resultData = responseData?responseData.response:[];
      this.dailyGraphData = responseData.response?responseData.response.locWiseDetails:[];
      var volDataArr: any = [];
      var wgtDataArr: any = [];
      var qtyDataArr: any = [];
      var volChartData: any = [];
      var filterLoc;
      var filterLocData: any = [];
      var fullVolData: any = [];
      var fullWgtData: any = [];
      var fullQtyData: any = [];

      var wgtChartData: any = [];
      var qtyChartData: any = [];

      if (this.locCode != null) {
        this.locCode.forEach(function (value, key) {
          filterLoc = responseData.response.locWiseDetails.filter(item => item.locationName == value.itemName);
          filterLocData.push(filterLoc[0]);
        });

        if (filterLocData.length > 0) {
          graphLoopData = filterLocData;
        } else {
          graphLoopData = responseData.response.locWiseDetails;
        }
      }

      if (graphLoopData) {
        graphLoopData.forEach(function (value, key) {

          let gvoldata = [];
          let gwgtdata = [];
          let gqtydata = [];
          // gvoldata.push(value.avgLocVolume);
          // gwgtdata.push(value.avgLocWeight);
          // gqtydata.push(value.avgLocQty);

          locName.push(value.locationName);

          value.totalLocationWiseSumDayDetails.forEach(function (val, k) {
            gvoldata.push(val.sumVolume);
            gwgtdata.push(val.sumWeight);
            gqtydata.push(val.sumQuantity);
          });
          fullVolData.push(gvoldata);
          fullWgtData.push(gwgtdata);
          fullQtyData.push(gqtydata);

          volChartData.push(fullVolData);
          wgtChartData.push(fullWgtData);
          qtyChartData.push(fullQtyData);
        });
      }

      volChartData.forEach(function (value, key) {
        volDataArr.push({ data: value[key], label: locName[key] })
      });

      wgtChartData.forEach(function (value, key) {
        wgtDataArr.push({ data: value[key], label: locName[key] })
      });

      qtyChartData.forEach(function (value, key) {
        qtyDataArr.push({ data: value[key], label: locName[key] })
      });

      this.VolumeChartData = volDataArr;
      this.WeightChartData = wgtDataArr;
      this.QuantityChartData = qtyDataArr;

      this.spinner.hide();
    });
  }

}
